export function valueEqual(givenValue, expectedValue) {
    return givenValue === expectedValue;
}
//# sourceMappingURL=equal.js.map